import { DateTime } from 'luxon'

export default {
  durationId: 'last-30-days',
  durationStart: DateTime.now().minus({ days: 30 }).startOf('day'),
  durationEnd: DateTime.now().endOf('day'),
}
